import { React, useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Button from "@mui/material/Button";
import DoneIcon from "@mui/icons-material/Done";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ToastContainer, toast } from "react-toastify";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import "react-toastify/dist/ReactToastify.css";
import AddIcon from "@mui/icons-material/Add";
import colors from "assets/theme/base/colors";

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { set } from "date-fns";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
function EntryTestTemplate() {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    website: "",
    description: "",
    logo: "",
  });
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
  const cropperRef = useRef(null);
  const [logo, setLogo] = useState(null);
  const [croppedLogo, setCroppedLogo] = useState(null);
  const [openCropModal, setOpenCropModal] = useState(false);

  const handleImageUploadClick = () => {
    document.getElementById("imageUploadInput").click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setLogo(reader.result);
        setOpenCropModal(true); // Open crop modal when image is uploaded
      };
      reader.readAsDataURL(file);
    }
  };

  const onCrop = () => {
    const cropper = cropperRef.current.cropper;
    const croppedDataUrl = cropper.getCroppedCanvas().toDataURL();
    setCroppedLogo(croppedDataUrl);
    setFormData((prev) => ({ ...prev, logo: croppedDataUrl }));
    setOpenCropModal(false); // Close crop modal after cropping
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleOpenAddModal = () => {
    setOpenAddModal(true);
  };
  const handleOpenDeleteModal = (template) => {
    setSelectedTemplate(template);
    setOpenDeleteModal(true);
  };
  const handleOpenEditModal = (template) => {
    setFormData({
      name: template.name,
      phone: template.phone,
      email: template.email,
      website: template.website,
      description: template.description,
      logo: template.logo,
    });
    setSelectedTemplate(template);
    setOpenEditModal(true);
  };
  const getTemplates = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/entrytest/get_slip_templates`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );
      const data = await response.json();
      setTemplates(data.slip_templates);
    } catch (error) {
      console.log(error);
    }
  };
  const handleAdd = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/entrytest/add_slip_template`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      if (data.success) {
        toast.success("Template added successfully");
        setOpenAddModal(false);
        getTemplates();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleDelete = async () => {
    let id = selectedTemplate.id;
    try {
      const response = await fetch(
        `${BASE_URL}/entrytest/delete_slip_template/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        toast.success("Template deleted successfully");
        setOpenDeleteModal(false);
        getTemplates();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleEdit = async () => {
    let id = selectedTemplate.id;
    try {
      const response = await fetch(
        `${BASE_URL}/entrytest/update_slip_template/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      if (data.success) {
        toast.success("Template updated successfully");
        setOpenEditModal(false);
        getTemplates();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const columns = [
    { Header: "#", accessor: "id", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Phone", accessor: "phone", align: "left" },
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "Website", accessor: "website", align: "left" },
    { Header: "Action", accessor: "action", align: "center" },
  ];
  const rows =
    templates.length > 0
      ? templates.map((template, index) => {
          return {
            id: index + 1,
            name: template.name,
            phone: template.phone,
            email: template.email,
            website: template.website,
            action: (
              <>
                <IconButton
                  size="small"
                  onClick={() => handleOpenEditModal(template)}
                  style={{ color: "green" }}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  size="small"
                  style={{ color: "red" }}
                  onClick={() => handleOpenDeleteModal(template)}
                >
                  <DeleteIcon />
                </IconButton>
              </>
            ),
          };
        })
      : [];

  useEffect(() => {
    getTemplates();
  }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card
              className="mt-5"
              sx={{
                boxShadow: "none",
                border: "1px solid #DADADAEE",
                borderRadius: "5px",
              }}
            >
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper
                      component="form"
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "333px",
                        border: "1px solid #8C8C8C",
                        boxShadow: "none",
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        // value={searchKeyword}
                        // onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon
                        sx={{ color: "gray", width: "22px", height: "22px" }}
                      />
                    </Paper>
                  </Stack>
                  <Button
                    variant="filled"
                    endIcon={
                      <AddIcon
                        sx={{
                          width: "22px",
                          height: "22px",
                          marginLeft: "22px",
                        }}
                      />
                    }
                    onClick={handleOpenAddModal}
                    style={{
                      color: "white",
                      background: info.main,
                      fontWeight: 500,
                      height: "40px",
                      width: "120px",
                      fontSize: "16px",
                    }}
                  >
                    Add
                  </Button>
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {templates && templates.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src="nodata.png"
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Dialog
        open={openAddModal || openEditModal}
        onClose={() => setOpenAddModal(false)}
      >
        <DialogTitle>
          {openEditModal ? "Edit Template" : "Add Template"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{ position: "relative", textAlign: "center" }}
            >
              <img
                src={formData.logo || "/your_logo_here.png"}
                alt="Logo"
                style={{ width: "90%" }}
              />
              <IconButton
                style={{
                  position: "absolute",
                  bottom: "0",
                  right: "0",
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  padding: "5px",
                }}
                onClick={handleImageUploadClick}
              >
                <EditIcon />
              </IconButton>
              <input
                id="imageUploadInput"
                type="file"
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleImageChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control"
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                className="form-control"
                type="text"
                name="website"
                value={formData.website}
                onChange={handleChange}
                placeholder="Website"
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <ReactQuill
                theme="snow"
                style={{ height: "200px" }}
                value={formData.description}
                onChange={(content) =>
                  handleChange({
                    target: { name: "description", value: content },
                  })
                }
                placeholder="Description"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => (openEditModal ? handleEdit() : handleAdd())}>
            Save
          </Button>
          <Button
            onClick={() => (setOpenAddModal(false), setOpenEditModal(false))}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete Confirmation Modal */}
      <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
        <DialogTitle>Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button onClick={handleDelete} color="secondary">
            Yes
          </Button>
          <Button onClick={() => setOpenDeleteModal(false)}>No</Button>
        </DialogActions>
      </Dialog>
      {/* Cropper Modal */}
      <Dialog open={openCropModal} onClose={() => setOpenCropModal(false)}>
        <DialogTitle>Crop Logo</DialogTitle>
        <DialogContent>
          {logo && (
            <Cropper
              src={logo}
              style={{ height: 400, width: "100%" }}
              initialAspectRatio={16 / 9}
              guides={false}
              ref={cropperRef}
              viewMode={1}
              autoCropArea={1}
              background={false}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onCrop} color="primary">
            Crop & Save
          </Button>
          <Button onClick={() => setOpenCropModal(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default EntryTestTemplate;
